import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ProAllowanceContent } from '../components/pro-allowance/pro-allowance-content/pro-alowance-content';
import { ProAllowanceProvider } from '../context/pro-allowance-context';
var ProAllowanceLayout = function () {
    return (React.createElement(ErrorBoundary, { name: "proallowance-content" },
        React.createElement(ProAllowanceProvider, null,
            React.createElement(ProAllowanceContent, null))));
};
ProAllowanceLayout.displayName = 'ProAllowanceLayout';
export var ProAllowance = function () {
    return React.createElement(ProAllowanceLayout, null);
};
ProAllowance.displayName = 'ProAllowance';
